import { mdiPencil } from '@mdi/js';
import Icon from '@mdi/react';
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import PageLoading from '../../components/General/PageLoading';
import InboxList from '../../components/Inbox/InboxList';
import { useAuth } from '../../providers/AuthProvider';

const InboxIndex = () => {
  const router = useRouter();
  const { authLoaded, isLoggedIn, isAdmin } = useAuth();

  let isUsersInbox = true;
  if (router.query.uid && isAdmin) {
    isUsersInbox = false;
  }

  if (authLoaded && !isLoggedIn) {
    router.push('/home');
  }

  if (!authLoaded || !isLoggedIn) {
    return <PageLoading />;
  }

  return (
    <div className="inbox">
      <Head>
        <title>Shift.ms - Inbox</title>
      </Head>
      <div className="sticky-header chatroom-header">
        <div className="container is-narrow">
          {isUsersInbox ? (
            <>
              <div className="chatroom-header-name">
                <h1 className="">Inbox</h1>
              </div>
              <div className="chatroom-header-end field is-grouped">
                <div className="buttons">
                {isAdmin && (
                  <Link legacyBehavior href="/inbox/group">
                    <a className="button is-rounded">
                      <span className="icon">
                        <Icon path={mdiPencil} size={1} />
                      </span>
                      <span>New group</span>
                    </a>
                  </Link>
                )}
                  <Link legacyBehavior href="/inbox/new">
                    <a className="button is-primary is-rounded">
                      <span className="icon">
                        <Icon path={mdiPencil} size={1} />
                      </span>
                      <span>New message</span>
                    </a>
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <div className="chatroom-header-name">
              <h1>
                Viewing user&apos;s inbox:
                {router.query.uid}
              </h1>
            </div>
          )}
        </div>
      </div>
      <div className="container is-narrow">
        <InboxList />
      </div>
    </div>
  );
};
export default InboxIndex;
